import React from "react";
import GooglePayButton from "@google-pay/button-react";
import { GOOGLE_PAY_ENVIRONMENT, allowedCardsBrands } from "../../constants";

const GooglePay = ({ country, currency, price, merchantId, merchantName, externalMerchantId, disallowedCardBrands = [], onSuccess }) => {
    const onLoadPaymentData = async (paymentRequest) => {
        const {token} = paymentRequest.paymentMethodData.tokenizationData;
        await onSuccess(token);
    }

    const onReadyToPayChange = (result) => {
    }

    const environment = GOOGLE_PAY_ENVIRONMENT === 'NULL_GOOGLE_PAY_ENVIRONMENT' ? 'TEST' : GOOGLE_PAY_ENVIRONMENT;

    return (
        <div className="alternative-button">
            <GooglePayButton
                environment={environment}
                paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                        {
                            type: 'CARD', // - constant
                            parameters: {
                                allowedAuthMethods: ['PAN_ONLY'], // - constant
                                allowedCardNetworks: allowedCardsBrands.filter((brand) => !disallowedCardBrands.includes(brand)), // - maybe are returned from payment API
                            },
                            tokenizationSpecification: {
                                type: 'PAYMENT_GATEWAY', // - constant
                                parameters: {
                                    gateway: 'checkoutltd', // - constant
                                    gatewayMerchantId: merchantId,
                                },
                            },
                        },
                    ],
                    merchantInfo: {
                        merchantId: externalMerchantId,
                        merchantName: merchantName, // - from payment-info
                    },
                    transactionInfo: {
                        totalPriceStatus: 'FINAL', // - constant
                        totalPriceLabel: 'Total', // - constant
                        totalPrice: String(price), // - from payment-info, amount
                        currencyCode: currency, // - from payment-info, but need to check pay-in-list response
                        countryCode: country, // - from payment-info, but need to check pay-in-list response
                    },
                }}
                onLoadPaymentData={onLoadPaymentData}
                onReadyToPayChange={onReadyToPayChange}
            />
        </div>
    )
}

export default GooglePay;
